import { DatadogService } from 'const/monitoring/datadog'
import { PageId } from 'routing/pages'

export const RUM_SERVICE_MAP: Record<PageId, DatadogService> = {
    // AUTH
    authPage: DatadogService.AUTH,
    authForgotPasswordPage: DatadogService.AUTH,
    authInvitationSignupPage: DatadogService.AUTH,
    authOrganizationPage: DatadogService.AUTH,
    authResetPasswordPage: DatadogService.AUTH,
    authSignInMfaPage: DatadogService.AUTH,
    authSignInPage: DatadogService.AUTH,
    authSignUpMfaSetupPage: DatadogService.AUTH,
    authSignUpPage: DatadogService.AUTH,
    authVerifyEmailPage: DatadogService.AUTH,

    // HOMEPAGE
    homePage: DatadogService.HOMEPAGE,
    executiveHomePage: DatadogService.HOMEPAGE,

    // AI
    aiPage: DatadogService.AI,
    aiReportPrintPage: DatadogService.AI,
    aiReportSharedPage: DatadogService.AI,
    insightsPage: DatadogService.AI,

    // DASHBOARDS
    dashboardPage: DatadogService.DASHBOARDS,
    dashboardPrintPage: DatadogService.DASHBOARDS,
    homePagePrintPage: DatadogService.HOMEPAGE,
    dashboardsSummaryPage: DatadogService.DASHBOARDS,

    // AUTOMATION
    automationPage: DatadogService.AUTOMATION,
    automationProfilePage: DatadogService.AUTOMATION,
    rulebookPage: DatadogService.AUTOMATION,

    // AMAZON_ADVERTISING
    adAccountsSummaryPage: DatadogService.AMAZON_ADVERTISING,
    adAccountPage: DatadogService.AMAZON_ADVERTISING,
    brandCampaignPage: DatadogService.AMAZON_ADVERTISING,
    brandCampaignKeywordPage: DatadogService.AMAZON_ADVERTISING,
    brandCampaignProductAdPage: DatadogService.AMAZON_ADVERTISING,
    campaignsSummaryPage: DatadogService.AMAZON_ADVERTISING,
    campaignPage: DatadogService.AMAZON_ADVERTISING,
    amazonCampaignCreationPage: DatadogService.AMAZON_ADVERTISING,
    campaignKeywordPage: DatadogService.AMAZON_ADVERTISING,
    campaignProductAdPage: DatadogService.AMAZON_ADVERTISING,
    adGroupPage: DatadogService.AMAZON_ADVERTISING,
    adGroupKeywordPage: DatadogService.AMAZON_ADVERTISING,
    productsSummaryPage: DatadogService.AMAZON_ADVERTISING,
    productPage: DatadogService.AMAZON_ADVERTISING,
    productAdPage: DatadogService.AMAZON_ADVERTISING,
    productProductAdPage: DatadogService.AMAZON_ADVERTISING,
    portfoliosSummaryPage: DatadogService.AMAZON_ADVERTISING,
    portfolioPage: DatadogService.AMAZON_ADVERTISING,
    targetingSummaryPage: DatadogService.AMAZON_ADVERTISING,
    adGroupsSummaryPage: DatadogService.AMAZON_ADVERTISING,
    keywordPage: DatadogService.AMAZON_ADVERTISING,
    dspSummaryPage: DatadogService.AMAZON_ADVERTISING,
    dspAdvertiserPage: DatadogService.AMAZON_ADVERTISING,
    dspOrderPage: DatadogService.AMAZON_ADVERTISING,
    dspLineItemPage: DatadogService.AMAZON_ADVERTISING,

    // PRODUCT_CATALOG
    productCatalogPage: DatadogService.PRODUCT_CATALOG,
    productDetailPage: DatadogService.PRODUCT_CATALOG,

    // SEGMENTS
    segmentsSummaryPage: DatadogService.SEGMENTS,
    segmentPage: DatadogService.SEGMENTS,
    segmentCreationPage: DatadogService.SEGMENTS,
    segmentEditPage: DatadogService.SEGMENTS,
    marketAnalysis: DatadogService.MARKET_ANALYSIS,

    // SHARE_OF_VOICE
    sovKeywordsSummaryPage: DatadogService.SHARE_OF_VOICE,
    sovKeywordPage: DatadogService.SHARE_OF_VOICE,
    sovKeywordSearchResultPage: DatadogService.SHARE_OF_VOICE,

    // KEYWORD_RESEARCH
    keywordResearchPage: DatadogService.KEYWORD_RESEARCH,
    keywordResearchListsPage: DatadogService.KEYWORD_RESEARCH,
    keywordResearchListDetailPage: DatadogService.KEYWORD_RESEARCH,
    keywordResearchV2Page: DatadogService.KEYWORD_RESEARCH,

    // CATEGORY_PERFORMANCE
    categoryPerformancePage: DatadogService.CATEGORY_PERFORMANCE,
    categoryPerformanceSummaryPage: DatadogService.CATEGORY_PERFORMANCE,
    categoryDetailsPage: DatadogService.CATEGORY_PERFORMANCE,

    // DISTRIBUTION_ANALYSIS
    distributionAnalysisPage: DatadogService.DISTRIBUTION_ANALYSIS,

    // SYSTEM
    app: DatadogService.SYSTEM,
    reportsSummaryPage: DatadogService.SYSTEM,
    metricsGlossaryPage: DatadogService.SYSTEM,
    settingsPage: DatadogService.SYSTEM,
    alertPage: DatadogService.SYSTEM,
    alertCreationPage: DatadogService.SYSTEM,
    labelPage: DatadogService.SYSTEM,
    organizationGroupPage: DatadogService.SYSTEM,
    bulkUpdatesPage: DatadogService.SYSTEM,
    zendeskSSOPage: DatadogService.SYSTEM,
    debugColumnsPage: DatadogService.SYSTEM,
    debugIconsPage: DatadogService.SYSTEM,
    debugMetricsPage: DatadogService.SYSTEM,
    debugSandboxPage: DatadogService.SYSTEM,
}

// Pages here will NOT start a new RUM view on tab changes.
// Use for routes with dynamic IDs where tab UUIDs would create high-cardinality view names.
export const SKIP_TAB_TRACKING = new Set<PageId>([
    'homePage',
    'dashboardPage',
    'dashboardPrintPage',
])
